import sendToScount from './sendToScount';

function parseAtobToJson(dataBase64) {
  let dataJson;

  try {
    dataJson = window.atob(dataBase64);
  } catch (err) {
    console.error('atobError', err);
  }

  if (!dataJson) return;

  let parsedData = null;

  try {
    parsedData = JSON.parse(dataJson);
  } catch (err) {
    console.error('no valid json in base64');
  }

  return parsedData;
}

export default (races, eventInfo) => {
  const currentUrlParams = new URL(window.location).searchParams;
  const dataBase64 = currentUrlParams.get('data');

  if (!dataBase64) return;

  const parsedData = parseAtobToJson(dataBase64);

  if (!parsedData) return;

  const eventParsedData = parsedData.Events.find((event) => event.EventId.toLowerCase() === eventInfo.Id.toLowerCase());

  const dataRaces = (eventParsedData?.Races || []).map((race) => race?.toLowerCase());
  const dataSessionId = parsedData?.SessionId;
  const disciplines = parsedData?.Disciplines;
  const participatedRaces = races.filter((race) => race.ism).map((race) => (
    { raceId: race.id, participantId: race.ParticipantId }
  ));
  const isParticipatedInRaces = dataRaces && participatedRaces.some((race) => dataRaces.includes(race.raceId));

  const needToSendToScount = [
    isParticipatedInRaces,
    participatedRaces.length && !dataRaces,
  ].some(Boolean);

  if (needToSendToScount) {
    sendToScount(dataSessionId, participatedRaces[0].participantId);
    return;
  }

  const filteredRaces = races.filter((race) => (dataRaces || []).includes(race.id));

  if (filteredRaces.length) {
    return {
      dataSessionId,
      races: filteredRaces.map((race) => race.id),
    };
  }

  const filteredByDisciplines = (filteredRaces.length ? filteredRaces : races).filter((race) => (disciplines || []).includes(race.dc));

  if (disciplines && filteredByDisciplines.length) {
    return {
      dataSessionId,
      races: filteredByDisciplines.map((race) => race.id),
    };
  }
  console.log({ filteredRaces, filteredByDisciplines, races });

  return {
    dataSessionId,
    races: races.map((race) => race.id),
  };
};
